export const callAllFns = <T extends (...args: any[]) => any>(...fns: T[]) => (
    ...args: Parameters<T>
) => {
    for (const fn of fns) fn(...args);
};

export const once = <T extends (...args: any) => any>(f: T): T => {
    let r: ReturnType<T>;
    return ((...args) => {
        if (f) {
            r = f(...args);
            f = null;
        }
        return r;
    }) as any;
};

export const noopFn = () => {};
